// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app{
  position:relative;
  display:flex;
  flex-direction:column;
  min-width:20rem;
  min-height:100%;
}

  .app > main{
    flex-grow:1;
    height:100%;
  }

  .app--white-background{
    background-color:#fff;
  }

  .app__header-shadow{
    width:100%;
    height:0.0625rem;
    margin-top:-0.0625rem;
    background-color:#f6f7f8;
    box-shadow:0 0.125rem 0.25rem rgb(0, 0, 0, 0.1);
  }

  .app .inlineSVG{
    display:none;
  }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
